import axios from "axios"
import { isProduction } from "@custouch/proxy-use"

const request = axios.create({})
const cdpOpenApiBaseUrl = `https://open.${isProduction ? "cloud" : "beta"}.custouch.com`
let cdpLoginPromise
let anonymousId

export const PostCdpLogin = ({ tenantId, teamId, body }) => {
    if (cdpLoginPromise) return cdpLoginPromise

    cdpLoginPromise = request
        .post(`${cdpOpenApiBaseUrl}/platform/cdp/${tenantId}/${teamId}/auth/login`, body, {
            headers: {
                "Content-Type": "application/json"
            }
        })
        .then((response) => {
            anonymousId = response.data.result.anonymousId
            return response
        })

    return cdpLoginPromise
}

export const PostCollect = async (body) => {
    if (window.env && window.env.__IS_CUSTOUCH_ENV) {
        if (cdpLoginPromise) {
            try {
                await cdpLoginPromise
            } catch (error) {
                // CDP 登录失败不阻止事件上报
            }
        }

        return request.post(
            `${window.env.__IS_LOCAL ? "https://alibabaceshi.beta.pageseagle.com" : ""}/collect/event`,
            body,
            anonymousId
                ? {
                      headers: {
                          "X-Tracking-ID": anonymousId
                      }
                  }
                : undefined
        )
    }
    return
}
